/**
 * All paths owned by Operations Center that should NOT highlight other
 * tabs when the `operations-center` flag is on. The sole consumer today
 * is `getExperiencesPaths`, which filters these out of the Experiences
 * tab's active-state paths to prevent double-highlighting.
 *
 * Note: not all entries were "moved from Experiences" — `/responses` and
 * `/reports/feedback` come from the Feedback tab (replaced entirely by
 * OC), `/user_support` from the Profile dropdown, `/recovery_ai` from
 * a standalone top-level tab, and `/ordering_management` from Experiences.
 */
export const operationsCenterMovedPaths = [
  '/responses',
  '/reports/feedback',
  '/ordering_management',
  '/user_support',
  '/recovery_ai',
]

export const paths = {
  campaigns: {
    paths: ['/thanx_campaigns', '/thanx_campaigns/performance'],
    id: '0',
  },
  loyalty: {
    paths: ['/points', '/loyalty'],
    id: '1',
  },
  rewards: {
    paths: ['/rewards'],
    id: '2',
  },
  customers: {
    paths: [
      '/users',
      '/user_lists',
      '/reports/customer',
      '/reports/lifecycle',
      '/reports/activation',
      '/reports/retention_rate',
      '/reports/revenue',
      '/reports/purchases',
      '/reports/capture_rate',
      '/reports/suppressions',
    ],
    id: '3',
  },
  feedback: {
    paths: ['/responses', '/reports/feedback'],
    id: '4',
  },
  operations_center: {
    paths: [
      '/responses',
      '/reports/feedback',
      '/order_feedback',
      '/order_ratings',
      '/reports/ordering_error_report',
      '/ordering_management',
      '/user_support',
      '/recovery_ai',
      '/alert_banners',
      '/locations',
      '/delivery_location_settings',
    ],
    id: '9',
  },
  experiences: {
    paths: [
      '/brand_content',
      '/live_updates',
      '/ordering_management',
      '/reports/ordering_conversion',
      '/gift_cards',
    ],
    id: '5',
  },
  games: {
    paths: ['/games'],
    id: '6',
  },
  settings: {
    paths: ['/settings'],
    id: '7',
  },
}

export const NAV_KEYS = {
  FEEDBACK: 'feedback',
  OPERATIONS_CENTER: 'operations_center',
} as const

/**
 * Returns the active-state paths for the Digital Experiences tab. When the
 * Operations Center flag is on, paths that have moved into Operations Center
 * are excluded so only one tab highlights at a time.
 */
export const getExperiencesPaths = (
  operationsCenterEnabled: boolean
): string[] =>
  operationsCenterEnabled
    ? paths.experiences.paths.filter(
        p => !operationsCenterMovedPaths.includes(p)
      )
    : paths.experiences.paths
